module.exports = __webpack_public_path__ + "img/9.36231501.jpg";